export default "Harberger Taxes <b>reduce investor hoarding</b> and <b>extreme wealth accumulation</b>.\n";